module.exports = __webpack_public_path__ + "static/media/dropdown_arrow_white.59899dd8.svg";